export function encode(str) {
    let buf = [];

    for (let i=str.length-1;i>=0;i--) {
        buf.unshift(['&#', str[i].charCodeAt(), ';'].join(''))
    }

    return buf.join('')
}

export function decode(str) {
    return str.replace(/&#(\d+);/g, function(match, dec) {
        return String.fromCharCode(dec)
    })
}

function link(str) {
    return `<a data-lto="${encode(str)}">{*${str}*}${encode(str)}</a>`
}


// WEBPACK FOOTER //
// ./utils/htmlentities.js